module.exports = __webpack_public_path__ + "static/logo-d2f58a0273235c1c3cbfa8a59c6c6871.png";